// Die Uebersicht der Tastenkuerzel (ST-UX-001, CM-UX-001: "Shortcuts sind
// dokumentiert") mit dem Schalter fuer die Einzeltasten (WCAG 2.1.4).
//
// Nur Kuerzel, die es gibt (ADR-0002: keine Attrappe): Listen-Tasten und
// Strg+Enter im Verlauf kommen mit ihren Slices dazu.

import type { ReactElement } from 'react';
import {
  Body1,
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Switch,
  makeStyles,
  tokens,
} from '@fluentui/react-components';

import { Tasten } from './taste.tsx';
import { istMacTastatur, kuerzelZeilen } from './tastenkuerzel.ts';
import { NebenKnopf } from './nebenknopf.tsx';

const useStyles = makeStyles({
  tabelle: { borderCollapse: 'collapse', width: '100%' },
  zelle: {
    textAlign: 'left',
    padding: '0.5rem 0.75rem 0.5rem 0',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    verticalAlign: 'top',
  },
  inhalt: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
});

export function KuerzelUebersicht({
  darfAnlegen,
  darfKontakte,
  darfWiedervorlagen,
  notizAngemeldet,
  einzeltasten,
  onEinzeltasten,
  onSchliessen,
}: {
  readonly darfAnlegen: boolean;
  readonly darfKontakte: boolean;
  readonly darfWiedervorlagen: boolean;
  /** Ein Bildschirm hat den Kontextbefehl "notiz" angemeldet; nur dann gibt es C. */
  readonly notizAngemeldet: boolean;
  readonly einzeltasten: boolean;
  readonly onEinzeltasten: (an: boolean) => void;
  readonly onSchliessen: () => void;
}): ReactElement {
  const styles = useStyles();
  const mac = istMacTastatur();
  return (
    <Dialog open modalType="modal" onOpenChange={(_, daten) => { if (!daten.open) onSchliessen(); }}>
      <DialogSurface aria-describedby="kuerzel-hinweis">
        <DialogBody>
          <DialogTitle>Tastenkürzel</DialogTitle>
          <DialogContent className={styles.inhalt}>
            <table className={styles.tabelle}>
              <thead>
                <tr>
                  <th scope="col" className={styles.zelle}>Taste</th>
                  <th scope="col" className={styles.zelle}>Wirkung</th>
                </tr>
              </thead>
              <tbody>
                {kuerzelZeilen({ darfAnlegen, darfKontakte, darfWiedervorlagen, notizAngemeldet }, mac).map((zeile) => (
                  <tr key={zeile.wirkung}>
                    <td className={styles.zelle}>
                      {zeile.tasten.map((taste, index) => (
                        <span key={taste}>
                          {index > 0 ? (zeile.nacheinander ? ' dann ' : ' + ') : ''}
                          <Tasten folge={taste} />
                        </span>
                      ))}
                    </td>
                    <td className={styles.zelle}>{zeile.wirkung}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Body1 id="kuerzel-hinweis">Einzeltasten wirken nicht, solange du in einem Feld schreibst.</Body1>
            <Switch
              checked={einzeltasten}
              onChange={(_, daten) => onEinzeltasten(daten.checked)}
              label="Einzeltasten verwenden"
            />
          </DialogContent>
          <DialogActions>
            <NebenKnopf onClick={onSchliessen}>
              Schließen
            </NebenKnopf>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
